import { render, staticRenderFns } from "./startList.vue?vue&type=template&id=5b503798&scoped=true"
import script from "./startList.vue?vue&type=script&lang=js"
export * from "./startList.vue?vue&type=script&lang=js"
import style0 from "./startList.vue?vue&type=style&index=0&id=5b503798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b503798",
  null
  
)

export default component.exports